import * as React from 'react'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ContractTips from 'modules/employees/pages/ImportContractsPage/components/ContractTips'

interface InfoProps {
  errorMessage?: string
}

const InfoComponent = ({ errorMessage }: InfoProps) => {
  if (errorMessage) {
    return (
      <Alert color="error">
        <Box alignItems="flexStart" flexDirection="row" gap="s12">
          <Box flexNoShrink>
            <Icon.Medium icon="alert-circle" color="grey800" />
          </Box>
          <Text.Normal>{errorMessage}</Text.Normal>
        </Box>
      </Alert>
    )
  }

  return <ContractTips />
}

export default observer(InfoComponent)
